import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJMobileImageToImageEdit.module.less';
import FJMobileArrow from '../../../assets/svg/mobile-arrow.svg?react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJMobileStyleListContainer from '../FJMobileStyleList/FJMobileStyleListContainer';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJMobileQuantityContainer from '../FJMobileQuantity/FJMobileQuantityContainer';
import FJMobileImageToImageInputContainer from '../FJMobileImageToImageInput/FJMobileImageToImageInputContainer';

const FJMobileImageToImageEdit = props => {
    const {
        generateQuantity,
        onGenerate,
        taskStatus,
        isProjectLoading,
        freeNumCreation,
        creditNumber,
        onExpandEdit,
        isExpandEdit,
    } = props;

    const useCredit = generateQuantity * 2;
    const isFree = freeNumCreation > 0 && generateQuantity * 2 > creditNumber && generateQuantity < 3;

    return (
        <div className={styles.container}>
            <div className={styles.header} onClick={onExpandEdit}>
                <div className={styles.title}>{FJLocalStore._('image-settings')}</div>
                <FJMobileArrow className={!isExpandEdit ? styles.arrow_up : ''} />
            </div>
            <div className={classNames(styles.inner, isExpandEdit ? styles.show : styles.hide)}>
                <FJMobileImageToImageInputContainer />
                <FJMobileStyleListContainer />
                <FJMobileQuantityContainer />
            </div>
            <div className={styles.btn_box}>
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    className={styles.btn}
                />
            </div>
        </div>
    );
};
FJMobileImageToImageEdit.propTypes = {
    generateQuantity: PropTypes.number,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    onExpandEdit: PropTypes.func,
    isExpandEdit: PropTypes.bool,
};
export default FJMobileImageToImageEdit;
